{
  class svgClipPath extends HTMLElement {

    constructor() {
      super()
      const target = this.getAttribute('target')
      this.targetSvg = document.querySelector(`${target}`)
      if (this.targetSvg) {
        this._init()
      } else {
        console.error(this, `Could not find ${target}`)
      }
    }

    _init() {
      if (!this.targetSvg.getAttribute('viewBox')) {
        console.error(this.targetSvg, 'Missing viewBox')
        return
      }

      if (this.targetSvg.children.length != 1) {
        console.error(this.targetSvg, 'SVG may only contain one child')
        return
      }

      if (!this.targetSvg.hasAttribute('converted')) {
        this.targetSvg.setAttribute('converted', true)

        const def = window.coolHelperFunctions.wrap(this.targetSvg, 'defs')
        def.setAttribute('height', 0)
        this.targetSvg.setAttribute('height', 0)

        const originalViewBox = this.targetSvg.getAttribute('viewBox').split(' ').map(i => parseInt(i)) //get an array like: [ 0, 0, 100, 100 ]
        this.targetSvg.removeAttribute('viewbox')

        const clipPath = window.coolHelperFunctions.wrap(this.targetSvg.children[0], 'clipPath', "http://www.w3.org/2000/svg")
        clipPath.setAttributeNS(null, 'clipPathUnits', 'objectBoundingBox')
        clipPath.id = window.coolHelperFunctions.generateID()

        const scale_x = 1 / originalViewBox[2]
        const scale_y = 1 / originalViewBox[3]
        clipPath.children[0].setAttribute('transform', `scale(${scale_x} ${scale_y})`)

        this.style.display = 'block'
        this.style.clipPath = `url(#${clipPath.id})`
      } else {
        const clipPath = this.targetSvg.children[0]
        this.style.display = 'block'
        this.style.clipPath = `url(#${clipPath.id})`
      }
    }
  }

  customElements.define("svg-clip-path", svgClipPath)
}